/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-07 17:43:44
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-07 18:02:34
 */
import Vue from 'vue'
import mrc_ess_svgIcon from '@/components/mrc_ess_svgIcon'// svg组件

// register globally
Vue.component('mrc_ess_svgIcon', mrc_ess_svgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', true, /\.svg$/)
requireAll(req)